'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['display:flex;> *:first-child{padding-left:0;}> *:last-child{padding-right:0;}'], ['display:flex;> *:first-child{padding-left:0;}> *:last-child{padding-right:0;}']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Nav = _styledComponents2.default.div(_templateObject);

exports.default = Nav;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/LandingHeader/Nav.js
// module id = 203
// module chunks = 4